import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';
import Spinner from '../../shared/styleguide/Spinner';
var RolesForm = /*#__PURE__*/ React.lazy(function() {
    return import('./RoleForm');
});
var RolesList = /*#__PURE__*/ React.lazy(function() {
    return import('./RolesList');
});
var RoleManagementRoutes = function RoleManagementRoutes() {
    return /*#__PURE__*/ _jsx(React.Fragment, {
        children: /*#__PURE__*/ _jsx(Suspense, {
            fallback: /*#__PURE__*/ _jsx(Spinner, {}),
            children: /*#__PURE__*/ _jsxs(Routes, {
                children: [
                    /*#__PURE__*/ _jsx(Route, {
                        path: "/*",
                        element: /*#__PURE__*/ _jsx(RolesList, {})
                    }),
                    /*#__PURE__*/ _jsx(Route, {
                        path: '/roles',
                        element: /*#__PURE__*/ _jsx(RolesList, {})
                    }),
                    /*#__PURE__*/ _jsx(Route, {
                        path: '/roles/:roleId',
                        element: /*#__PURE__*/ _jsx(RolesForm, {})
                    }),
                    /*#__PURE__*/ _jsx(Route, {
                        path: '/roles/add',
                        element: /*#__PURE__*/ _jsx(RolesForm, {})
                    })
                ]
            })
        })
    });
};
export default RoleManagementRoutes;
